import CompanyIcon from './CompanyIcon';

export default CompanyIcon;
